import { filter, first, last, sortBy } from 'lodash';

export function bestSaleMeet (sales, subtotal) {
  return last(sortBy(filter(sales, sale => sale.min <= subtotal), 'receive_amount'));
}

export function nextBestSaleMeet (sales, subtotal) {
  return first(sortBy(filter(sales, sale => sale.min > subtotal), 'min'));
}
